import React from 'react';
import { LockIcon, ShieldIcon, DownloadIcon, EyeOffIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function TrustBar() {
  return <section className="bg-white border-y border-gray-200 py-12 px-4" data-id="element-293">
      <div className="max-w-7xl mx-auto" data-id="element-294">
        <div className="text-center mb-8" data-id="element-295">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-296">
            <LockIcon className="w-6 h-6 text-green-600" data-id="element-297" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-298">
              Transazione Sicura al 100%
            </h3>
          </div>
          <p className="text-gray-600" data-id="element-299">
            I tuoi dati sono protetti con crittografia SSL a 256 bit
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-8" data-id="element-300">
          <div className="text-center" data-id="element-301">
            <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-302">
              <LockIcon className="w-8 h-8 text-blue-600" data-id="element-303" />
            </div>
            <div className="font-bold text-gray-900 mb-1" data-id="element-304">Pagamento Sicuro</div>
            <div className="text-sm text-gray-600" data-id="element-305">
              Crittografia SSL 256-bit
            </div>
          </div>

          <div className="text-center" data-id="element-306">
            <div className="bg-green-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-307">
              <ShieldIcon className="w-8 h-8 text-green-600" data-id="element-308" />
            </div>
            <div className="font-bold text-gray-900 mb-1" data-id="element-309">Garanzia 100%</div>
            <div className="text-sm text-gray-600" data-id="element-310">45 giorni di prova</div>
          </div>

          <div className="text-center" data-id="element-311">
            <div className="bg-orange-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-312">
              <DownloadIcon className="w-8 h-8 text-orange-600" data-id="element-313" />
            </div>
            <div className="font-bold text-gray-900 mb-1" data-id="element-314">
              Accesso Immediato
            </div>
            <div className="text-sm text-gray-600" data-id="element-315">Download istantaneo</div>
          </div>

          <div className="text-center" data-id="element-316">
            <div className="bg-purple-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-317">
              <EyeOffIcon className="w-8 h-8 text-purple-600" data-id="element-318" />
            </div>
            <div className="font-bold text-gray-900 mb-1" data-id="element-319">Privacy Protetta</div>
            <div className="text-sm text-gray-600" data-id="element-320">
              Dati personali al sicuro
            </div>
          </div>

          <div className="text-center" data-id="element-321">
            <div className="bg-red-50 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-322">
              <MailIcon className="w-8 h-8 text-red-600" data-id="element-323" />
            </div>
            <div className="font-bold text-gray-900 mb-1" data-id="element-324">
              Supporto Dedicato
            </div>
            <div className="text-sm text-gray-600" data-id="element-325">Assistenza via email</div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-326">
          <PaymentBadges data-id="element-327" />
        </div>
      </div>
    </section>;
}